export var getDisplayLevel = function getDisplayLevel(kycConfig, currentLevel) {
  if (!kycConfig) return null;
  return kycConfig.levels.filter(function (kycLevel) {
    return kycLevel.level === currentLevel;
  })[0];
};